export const getCleanedInvoiceNumber = (invoiceNumber) => {
  return invoiceNumber?.replace(/\s*(Updated|Archived)\s*\(\d+\)\s*$/, "");
};
